import React from 'react';
import Hero from '../components/home/Hero';
import FeaturedServices from '../components/home/FeaturedServices';
import FindMeAt from '../components/home/FindMeAt';
import CallToAction from '../components/home/CallToAction';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <FeaturedServices />
      <FindMeAt />
      <CallToAction />
    </>
  );
};

export default HomePage;